/** Bytes as base64url: base64 with `-` and `_` instead of `+` and `/`, and without `=` at the end, so it fits in a URL. */
export function toBase64url(bytes: Uint8Array): string {
    let binary = "";

    for (const byte of bytes) binary += String.fromCharCode(byte);

    return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
}

/** The bytes base64url text stands for. Throws when it isn't base64url. */
export function fromBase64url(text: string): Uint8Array<ArrayBuffer> {
    if (!/^[A-Za-z0-9_-]*$/.test(text)) throw new Error("That's not base64url.");

    const binary = atob(text.replaceAll("-", "+").replaceAll("_", "/"));

    return Uint8Array.from(binary, (char) => char.charCodeAt(0));
}
